import { Modal, Button } from "react-bootstrap";
import SbCancelBtn from "../Buttons/Buttons";
import { loadSettingsHolidayPolicyData } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const ViewLeavesModal = ({ show, handleClose, position = "right", setDataLoading }) => {
    const dispatch = useDispatch();
    const { getHolidayPolicyData = [] } = useSelector((state) => state.data);

    useEffect(() => {
        dispatch(loadSettingsHolidayPolicyData(setDataLoading));
    }, []);
    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName={`modal-${position}`}
            className={`modal fade ${position}`} // apply left or right
            backdropClassName="custom-backdrop"
            centered={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Leave Details</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "90vh", overflowY: "auto" }}>
                {getHolidayPolicyData.map((holiday) => (
                    <div key={holiday.HolidayID} className="holiday-card">
                        <h5>{holiday.HolidayName}</h5>
                        <p>
                            <strong>From:</strong>{" "}
                            <span>{new Date(holiday.HolidayFromDate).toLocaleDateString()}{" "}</span>
                            <strong>To:</strong>{" "}
                            <span>{new Date(holiday.HolidayToDate).toLocaleDateString()}</span>
                        </p>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Close" onClickEffect={handleClose} />
            </Modal.Footer>
        </Modal>
    );
};

export default ViewLeavesModal;
